import { render, staticRenderFns } from "./goDialogAssortment.vue?vue&type=template&id=35af4e98"
import script from "./goDialogAssortment.vue?vue&type=script&lang=js"
export * from "./goDialogAssortment.vue?vue&type=script&lang=js"
import style0 from "./goDialogAssortment.vue?vue&type=style&index=0&id=35af4e98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports